/* ═══════════════════════════════════════════════════════════════
   HERBAL CUP TEA — Shipping & Returns FAQ accordion
   Event-delegated so we work whether the script fires before or after
   the FAQ section is in the DOM. Uses an explicit `is-open` class
   instead of the [hidden] attribute to avoid silent CSS overrides.
   ═══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.ship-faq__trigger');
    if (!trigger) return;

    var panelId = trigger.getAttribute('aria-controls');
    var panel = panelId && document.getElementById(panelId);
    if (!panel) return;

    var willOpen = trigger.getAttribute('aria-expanded') !== 'true';
    trigger.setAttribute('aria-expanded', String(willOpen));

    if (willOpen) {
      panel.removeAttribute('hidden');
      panel.classList.add('is-open');
    } else {
      panel.setAttribute('hidden', '');
      panel.classList.remove('is-open');
    }
  });
})();
